import React from 'react'

const Subtitle = ({ color, title, category, angle }) => {
  return (
    <>
      <div
        className='cardBox'
        style={{ background: color, transform: `rotate(` + angle + `deg)` }}
      >
        {category}
      </div>
      <h3 className='subHeader'>{title}</h3>
    </>
  )
}
export default Subtitle
